import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarOpen: boolean;
  language: string;
  persistLanguage: boolean;
  showLoginModal: boolean;
  
  // Actions
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setLanguage: (language: string, persist: boolean) => void;
  setShowLoginModal: (show: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      language: 'en',
      persistLanguage: false,
      showLoginModal: false,

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      
      setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
      
      setLanguage: (language: string, persist: boolean) => 
        set({ language, persistLanguage: persist }),
      
      setShowLoginModal: (show: boolean) => set({ showLoginModal: show }),
    }),
    {
      name: 'ui-storage',
      partialize: (state) => 
        state.persistLanguage 
          ? { language: state.language, persistLanguage: state.persistLanguage }
          : { persistLanguage: false },
    }
  )
);
